import React, { useState, useEffect } from "react";
import { Icon } from "xsolla-uikit";
import { faqs } from "./Chat";
import { ConnectSlack } from "./ConnectSlack";
export const ChatBody = ({ shown, handle }) => {
  const [active, setActive] = useState(0);
  const [shown2, setShown2] = useState(false);
  const [shown3, setShown3] = useState(false);
  useEffect(() => {
    if (!shown) {
      setTimeout(() => {
        setShown2(shown);
      }, 10);
      setTimeout(() => {
        setShown3(shown);
      }, 80);
    }
    else {
      setTimeout(() => {
        setShown3(shown);
      }, 10);
      setTimeout(() => {
        setShown2(shown);
      }, 80);
    }
  }, [shown]);
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.async = true;
  //   script.innerHTML = `
  //     var mySwiper_xsb_howtos = new Swiper('#xsb_howtos', {
  //       slidesPerView : 1,
  //       direction: 'horizontal',
  //       setWrapperSize: true,
  //       // wrapperClass: 'swiper-wrapper__howtos',
  //       // slideClass: 'swiper-slide__howtos',
  //     });
  //   `;
  //   // setTimeout(() => {
  //     document.body.appendChild(script);
  //   // }, 100);
  // }, []);
  return (<div data-a="target0" className={`xsb_how0 ${shown ? "shown" : shown3 ? "shown" : ""}`}>
    <div
      // onClick={(e)=>e.preventDefault()}
      onClick={handle} data-a="target" className={`xsb_z ${shown2 ? "shown" : ""}`} />

    <div data-a="target2" className={`xsb_how_cont ${shown2 ? "shown" : ""}`}>
      <div className="xsb_hint_inner">
        <div className="xsb_pop_line xsb_pop_line--h">
          <div className="xsb_menu_h">
            <div data-xsb-localization="howtos_title">
              Answers based on your activity
              </div>
          </div>

          <div onClick={handle} id="xsb_how_close" data-a="trigger" className={`xsb_bt xsb_bt--close xsb_bt--close--sett ${shown3 ? "shown" : ""}`}>
            <div>close</div>

            <div data-a="target" className={`xsb_how_trigger_indicator ${shown3 ? "shown" : ""}`} />
          </div>
        </div>

        <div className="xsb_pop_line xsb_pop_line--faq" style={{ width: "100%" }}>
          <div id="xsb_howtos" className="swiper-container swiper-container__howtos">
            <div className="swiper-wrapper swiper-wrapper__howtos">


              <div className="swiper-slide swiper-slide__howtos">
                <div className="xsb_help_video w-embed w-iframe">
                  <iframe className="xsb_help_video" src={faqs[active]["video"]} allow="autoplay; encrypted-media" allowFullScreen />
                </div>

                <div className="xsb_help_faq0">
                  <div className="xsb_pop_line">
                    <div className="xsb_help_faq">
                      <div>{faqs[active]["description"]}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="xsb_pop_line">
          <div className="xsb_pop_toipcs0">
            <div className="xsb_pop_htcontents">
              {faqs.map(({ id, video, description, title }, ind) => {
                return (<div onClick={() => {
                  // window['mySwiper_xsb_howtos'].slideTo(ind, 200);
                  setActive(ind);
                }} key={`q_${id}`} className={`xsb_pop__hintcontentbutton ${active === ind ? "active" : ""}`}>
                  {title}
                </div>);
              })}


            </div>
          </div>
        </div>

        <div className="xsb_pop_line">
          <div>
            <div className="xsb_pop_link xsb_pop_link--noline">
              <div data-xsb-localization="howtos_askquestion" className="xsb_how_link">
                Ask a question
                </div>
              <div className="xsb_set_hint">
                <div className="xsb_status" />
                <div data-xsb-localization="howtos_ask_note">
                  Partner support is live
                  </div>
              </div>
            </div>
          </div>
          <div className="xsb_pop_link">
            <div data-xsb-localization="howtos_askquestion" className="xsb_how_link">
              Leave Feedback or feature request
              </div>
          </div>
          <a href="https://developers.xsolla.com/doc/sitebuilder/" target="_blank" className="xsb_pop_link w-inline-block">
            <div data-xsb-localization="howtos_whatsnew" className="xsb_how_link l_flex">
              Developer Documentation <Icon name="new-tab" />
            </div>
          </a>

        </div>

        <div className="xsb_pop_line">
          <ConnectSlack />
        </div>

        <br />
      </div>
    </div>
    <div data-a="target" className={`xsb_how_bg ${shown2 ? "shown" : ""}`} />
  </div>);
};
